<script>
	let { class: className = '', ...props } = $props();
</script>

<svg class={className} fill="none" preserveAspectRatio="none" viewBox="0 0 38 47" {...props}>
	<path
		d="M37.145 34.871 18.95 46.242.758 34.872M37.145 12.13 18.95.757.758 12.13m18.193.757-8.49 5.307m16.982 0-8.49-5.307M18.948 23.5s-4.198-2.625-8.339-5.212m16.683 0L18.953 23.5m-8.493-5.307.153.095m16.836-.095-.152.095m-8.344 15.825 8.49-5.306m-8.492 5.306-8.49-5.306M.758 34.871l9.703-6.064m16.988 0-.152-.095m-16.684 0-.152.095m16.977 0 9.703 6.064M.758 22.742v1.516m0-12.129v10.613m0 12.129V24.258m36.39-12.129v10.613m0 0v1.516m0 10.613V24.258M10.61 18.193v.095m0 10.519v-.095m0 0v-6.728m16.687 6.728v.095m0-10.614v.095m0 10.424V18.288m-8.344 15.825V23.5m0 10.613v7.58m0-37.145v8.339m-8.485 5.307c-2.418-1.513-4.848-3.03-6.671-4.17m30.312 0-6.672 4.17m9.705-6.065-3.033 1.895"
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="1"
	/>
</svg>
